import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Link, PaginatedList } from "components/common";
import { Table, Alert } from "components/bootstrap";
import ForwarderRoutes from "forwarder/Routes";
import ForwarderStateBadge from "../states/ForwarderStateBadge";
const StyledBadge = styled("div")`
  margin-right: 20px;
`;
const ForwardersTable = styled(Table)`
  .searchHelpButton {
    cursor: help;
    padding: 0 0 0 2px;
    margin-left: 5px;
  }

  .popoverWide {
    max-width: 500px;
    min-width: 350px;
  }

  tr > th {
    &.rowName {
      width: 50%;
    }

    &.rowActions {
      width: 200px;
    }
  }
`;
const InputProfilesForwarderList = ({ forwarders, pagination, onPageChange = void 0 }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const _getForwardersTable = () => forwarders.map((forwarder) => /* @__PURE__ */ React.createElement("tr", { key: forwarder.id }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.details(forwarder.id) }, forwarder.title)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(StyledBadge, null, /* @__PURE__ */ React.createElement(ForwarderStateBadge, { forwarderId: forwarder.id }))), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.details(forwarder.id) }, t("input_profiles_forwarder_list.open_details")))));
  const _handlePageChange = (page, pageSize) => {
    onPageChange(page, pageSize, pagination.query);
  };
  if (forwarders.length === 0) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, t("input_profiles_forwarder_list.no_forwarders"));
  }
  return /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      onChange: _handlePageChange,
      totalItems: pagination.total,
      showPageSizeSelect: false,
      activePage: pagination.page,
      pageSize: pagination.perPage,
      useQueryParameter: false
    },
    /* @__PURE__ */ React.createElement(ForwardersTable, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", { className: "rowName" }, t("input_profiles_forwarder_list.name")), /* @__PURE__ */ React.createElement("th", { className: "rowStatus" }, t("input_profiles_forwarder_list.status")), /* @__PURE__ */ React.createElement("th", { className: "rowActions" }, t("input_profiles_forwarder_list.actions")))), /* @__PURE__ */ React.createElement("tbody", null, _getForwardersTable()))
  );
};
export default InputProfilesForwarderList;
